import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Label = function Label(_a) {
  var _b = _a.className,
    className = _b === void 0 ? "" : _b,
    children = _a.children;
  var labelClassNames = classNames(["py-xs", "px-sm", "font-bold", "rounded-base", "text-body", "inline-block", "whitespace-nowrap", "bg-light", "text-xs", "auto-qa-label", className]);
  return /*#__PURE__*/React.createElement("span", {
    className: labelClassNames
  }, children);
};
Label.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export { Label };
//# sourceMappingURL=index.es.js.map
